import { writable } from 'svelte/store';

export const totalRewards = writable(0);